








































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { FormFieldProps, FormFieldRules, IFormField, EnumDTO } from "../../Models/Components.model";
import ButtonList from "../Common/Buttons/ButtonList.vue";
import ParticaBaseForm from "../Base/ParticaBaseForm.vue";
import { ContentStreamLevelDTO, ContentStreamLevelDTORequiresCuration } from "../../Generated/ParticaAPI";
import ContentStreamLevel from "../../Views/ContentStream/ContentStreamLevel.vue";

@Component(
	{
		name: "ContentStreamLevelForm",
		components: { ButtonList }
	})
export default class ContentStreamLevelForm extends ParticaBaseForm<ContentStreamLevelDTO> {

	@Prop() private contentCost: number;
	@Prop() private numberArticles: number;

	private priceconfig =
		{
			props: { name: "price", placeholder: "Enter price", label: "Price of level", } as FormFieldProps,
			rules: { numeric: true, decimal: 2, } as FormFieldRules
		} as IFormField;

	private nameconfig =
		{
			props: { name: "name", placeholder: "Enter name", label: "Name of level", } as FormFieldProps,
			rules: { required: true, max: 50, min: 0, } as FormFieldRules
		} as IFormField;

	private descriptionconfig =
		{
			props: { name: "description", placeholder: "Enter description", label: "Description for level", } as FormFieldProps,
			rules: { required: true, max: 500, min: 0, } as FormFieldRules
		} as IFormField;

	private requiresCurationconfig =
		{
			props: {
				name: "requiresCuration",
				placeholder: "Does this level require tailoring",
				label: "Is tailoring required on this level", required: true,
				values: [
					{ label: "Requires Tailoring", value: "required" } as EnumDTO,
					{ label: "No Tailoring required", value: "notrequired" } as EnumDTO,],
			} as FormFieldProps,
			rules: { required: true, numeric: true } as FormFieldRules
		} as IFormField;

	private additionalInfoconfig =
		{
			props: {
				name: "additionalInfo",
				placeholder: "Enter Additional Information",
				label: "Additional information for tailoring",
				disabled: true,
			} as FormFieldProps,
			rules: { required: false, max: 500, min: 0, } as FormFieldRules
		} as IFormField;

	private articleCurationCostconfig =
		{
			props: {
				name: "articleCurationCost",
				placeholder: "Cost of tailoring the issue for each subscriber",
				label: "Cost of tailoring each issue.",
			} as FormFieldProps,
			rules: { required: true, decimal: 2 } as FormFieldRules
		} as IFormField;

	private guidconfig =
		{
			props: {
				name: "guid",
				placeholder: "",
				label: "GUID", disabled: true
			} as FormFieldProps,
			rules: { required: false } as FormFieldRules
		} as IFormField;


	private calculateCost(): string {
		if (this.model.requiresCuration === ContentStreamLevelDTORequiresCuration.Notrequired) {
			return "";
		}
		if (this.model.price === 0) {
			return "";
		}
		return `(suggested $${(this.model.price - this.contentCost)})`;
	}

	private showMin(): string {
		return `(min $${this.contentCost})`;
	}

	private async mounted() {
		this.priceconfig.rules.min_value = this.contentCost;
		this.checkinfo();
	}

	@Watch("model.requiresCuration")
	private checkinfo() {
		if (this.model.requiresCuration === ContentStreamLevelDTORequiresCuration.Notrequired) {
			this.additionalInfoconfig.props.disabled = true;
			this.additionalInfoconfig.rules.required = false;
		} else {
			this.additionalInfoconfig.props.disabled = false;
			this.additionalInfoconfig.rules.required = true;
		}
	}

}
